import { render, staticRenderFns } from "./mfa.vue?vue&type=template&id=16c576c4&scoped=true&"
import script from "./mfa.vue?vue&type=script&lang=js&"
export * from "./mfa.vue?vue&type=script&lang=js&"
import style0 from "./mfa.vue?vue&type=style&index=0&id=16c576c4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c576c4",
  null
  
)

export default component.exports